// The language of the app's own interface. Deliberately separate from the exam
// paper's `QuestionVersion` (wizard Step 0): a teacher may read the UI in Bengali
// while generating an English-version paper, so the two must not be coupled.
export const LANGUAGES = ['en', 'bn'] as const;

export type Language = (typeof LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'en';

export const LANGUAGE_STORAGE_KEY = 'tutor_language';

/** Each language named in its own script, so the choice reads to the person making it. */
export const LANGUAGE_LABELS: Record<Language, string> = {
  en: 'English',
  bn: 'বাংলা',
};

/** Short form for the toggle button, where there is no room for the full name. */
export const LANGUAGE_SHORT_LABELS: Record<Language, string> = {
  en: 'EN',
  bn: 'বাং',
};

export function isLanguage(value: string): value is Language {
  return (LANGUAGES as readonly string[]).includes(value);
}
